module.exports = __webpack_public_path__ + "img/slot_pp.fbf58b7b.png";